/* =========================================================
   BZ · Funil do carrinho deslizante (todas as páginas)
   upsell · downsell (aparece ao recusar o upsell) · cross-sell · order bump · timer
   ========================================================= */
(function () {
 "use strict";
 var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || "/";
 function refresh() { document.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true, detail: { open: true } })); }
 function post(url, data) {
  return fetch(root + url, { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: JSON.stringify(data) })
   .then(function (r) { return r.json(); });
 }
 /* estado do downsell (sobrevive à re-renderização do carrinho) */
 try { if (sessionStorage.getItem("bzUpsellDeclined") === "1") document.documentElement.classList.add("bz-upsell-declined"); } catch (e) {}
 document.addEventListener("click", function (e) {
  var add = e.target.closest("[data-bz-add]");
  if (add) {
   e.preventDefault();
   if (add.classList.contains("is-loading")) return;
   add.classList.add("is-loading");
   post("cart/add.js", { items: [{ id: Number(add.getAttribute("data-variant")), quantity: Number(add.getAttribute("data-qty") || 1) }] })
    .then(refresh).catch(function () {}).finally(function () { add.classList.remove("is-loading"); });
   return;
  }
  var decline = e.target.closest("[data-bz-decline]");
  if (decline) {
   e.preventDefault();
   document.documentElement.classList.add("bz-upsell-declined");
   try { sessionStorage.setItem("bzUpsellDeclined", "1"); } catch (err) {}
  }
 });
 document.addEventListener("change", function (e) {
  var bump = e.target.closest("[data-bz-bump]");
  if (!bump) return;
  var id = Number(bump.getAttribute("data-variant"));
  bump.disabled = true;
  var req = bump.checked ? post("cart/add.js", { items: [{ id: id, quantity: 1 }] }) : post("cart/change.js", { id: String(id), quantity: 0 });
  req.then(refresh).catch(function () {}).finally(function () { bump.disabled = false; });
 });
 /* timer de reserva do carrinho (reinicia quando zera) */
 function tick() {
  var els = document.querySelectorAll("[data-bz-timer]");
  if (!els.length || !els[0].offsetParent) return; /* só conta com o carrinho aberto */
  var mins = Number(els[0].getAttribute("data-minutes") || 10);
  var end = 0;
  try { end = Number(sessionStorage.getItem("bzCartTimerEnd") || 0); } catch (e) {}
  var now = Date.now();
  if (!end || end < now) { end = now + mins * 60000; try { sessionStorage.setItem("bzCartTimerEnd", String(end)); } catch (e) {} }
  var left = Math.max(0, Math.round((end - now) / 1000));
  var txt = String(Math.floor(left / 60)).padStart(2, "0") + ":" + String(left % 60).padStart(2, "0");
  els.forEach(function (el) { el.textContent = txt; });
 }
 setInterval(tick, 1000); tick();
})();
